import { useParams, useNavigate } from "react-router-dom";
import { useEffect } from "react";

// Public-facing shipment tracking page
// TODO: Implement shipment tracking for customers
export default function PublicShipmentPage() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!slug) {
      navigate("/", { replace: true });
    }
  }, [slug, navigate]);

  return <div>Not Implemented</div>;
}
